export const isSupportedObject = (shape) => {
  const supportedShapes = [
    'rect',
    'circle',
    'triangle',
    'oval',
    'diamond',
    'cylinder',
    'right-angle-triangle',
    'square',
    'ellipse',
    'image'
  ];

  return shape && supportedShapes.includes(shape.type);
};